import React, { useState, useEffect, useContext } from "react";

import { AppContext } from "../../../AppContext";

import DefaultForm from "./DefaultForm";

const ObaManualFormComp = (props) => {
  const [appContext, setAppContext] = useContext(AppContext);
  const isJwCole = appContext.clientId === "jwcole"?true:false;

  const [validation, setValidation] = useState({
        valid: true,
        
        businessName : true,
        businessType : true,
        businessDesc : true,
        businessAddress : true,
        yearlyIncome : true,
        compensationMethod : true,
        engagementTime : true,
        businessStructure : true,
        activityStartDate : true,
        isBusinessCustody : true,
        businessCustody : true,

        isDba : true,
        isDbaHomeState:true,
        businessNature:true,
        titlePosition:true,
        businessOrganizationName:true,
        isClientOwnSecurity:true,
        clientAccount:true,
        businessRelations:true,
        otherBusinessRelation:true,
        businessDuty:true,
        monthlySpentHours:true,
        businessUrl:true,
        isInvestSecurity:true,
        isFundraising:true,
        fundraisingDesc:true,
        isInvestmentRep:true,
        isEngageMoreThan10Percent:true,
        isIncomeMoreThan10Percent:true,
        isSolicitedInvest:true,
        solicitedInvestors:true,
        isActivityInvolve:true,
        activityInvolvedPeople:true,
        requiresTwoSignCheck:true,
        insuranceCovered:true,
        otherInfo:true,
        complyAudit:true,
        complyFee:true,
        complySolicitation:true

      });

      const validate = () => {

        const fields = {
          businessName: props.data.businessName ? true : false,
          businessType: props.data.businessType ? true : false,
          businessDesc: props.data.businessDesc ? true : false,
          businessAddress: props.data.businessAddress ? true : false,
          yearlyIncome: props.data.yearlyIncome ? true : false,
          compensationMethod: props.data.compensationMethod ? true : false,
          engagementTime: props.data.engagementTime ? true : false,
          businessStructure: props.data.businessStructure || isJwCole ? true : false,
          activityStartDate: props.data.activityStartDate ? true : false,
          isBusinessCustody:props.data.isBusinessCustody ? true:false,
          businessCustody: (props.data.businessCustody || props.data.isBusinessCustody === "No")? true : false,

          isDba:props.data.isDba || !isJwCole ? true:false,
          isDbaHomeState:props.data.isDbaHomeState || props.data.isDba !== "Yes" ?true:false,
          titlePosition:props.data.titlePosition || !isJwCole ? true:false,
          businessOrganizationName:props.data.businessOrganizationName || !isJwCole ? true:false,
          isClientOwnSecurity: !isJwCole || props.data.isClientOwnSecurity || (props.data.businessType !== "Corporation (Public)") ?true:false,
          //clientAccount:(props.data.clientAccount || !props.data.isClientOwnSecurity || props.data.isClientOwnSecurity ==="No" || !isJwCole)?true:false,
          businessRelations: !isJwCole || (props.data.businessRelations && props.data.businessRelations.length) ?true:false,
          otherBusinessRelation:(props.data.otherBusinessRelation  || !isJwCole || (props.data.businessRelations.map(p=>p.key).indexOf("OTHER")==-1)) ?true:false,
          businessDuty:props.data.businessDuty || !isJwCole ? true:false,
          isInvestSecurity:props.data.isInvestSecurity || !isJwCole ? true:false,
          isFundraising:props.data.isFundraising || !isJwCole ? true:false,
          fundraisingDesc:(props.data.fundraisingDesc || props.data.isFundraising === "No" || !isJwCole ) ?true:false,
          isInvestmentRep:props.data.isInvestmentRep || !isJwCole ? true:false,
          isEngageMoreThan10Percent:props.data.isEngageMoreThan10Percent || !isJwCole ? true:false,
          isIncomeMoreThan10Percent:props.data.isIncomeMoreThan10Percent || !isJwCole ? true:false,
          isSolicitedInvest:props.data.isSolicitedInvest || !isJwCole ? true:false,
          solicitedInvestors:( props.solicitedInvestors.length || props.data.isSolicitedInvest==="No") ?true:false,
          isActivityInvolve:props.data.isActivityInvolve || !isJwCole ? true:false,
          activityInvolvedPeople:(props.activityInvolvedPeople.length || props.data.isActivityInvolve === "No") ?true:false,
          requiresTwoSignCheck:props.data.requiresTwoSignCheck || !isJwCole ? true:false,
          insuranceCovered:props.data.insuranceCovered || !isJwCole ? true:false,
          complyAudit:props.data.complyAudit || !isJwCole ? true:false,
          complyFee:props.data.complyFee || !isJwCole ? true:false,
          complySolicitation:props.data.complySolicitation || !isJwCole ? true:false
        };
        
        const valid = Object.values(fields).every(Boolean);
        setValidation({...validation,...fields,valid});
        return valid;
      };


      const [showBusinessCustody, setShowBusinessCustody] = useState(false);

      const handleSaveClick = (e) => {
        if (!validate()) {
          return;
        }
        props.handleSaveClick(e);
      };
    
      useEffect(()=>{
        setShowBusinessCustody(props.data.isBusinessCustody === 'Yes')
      },[props.data.isBusinessCustody])
      

    return (
        
        <div className="form">
            <div className="form-header">
                <div className="form-header-label">{props.editorMode === "UPDATE"?"Update":"Create a New"} Outside Business Activities Request</div>
            </div>
                    
            <DefaultForm
            editorMode={props.editorMode}
            data={props.data}
            validation={validation}
            showBusinessCustody={showBusinessCustody}
            handleChange = {props.handleChange}
            handleDateChange = {props.handleDateChange}
            />


          <div className="form-footer">
            {validation.valid ? (
                <div className="form-status"></div>
                ) : (
                    <div className="form-status error">Enter Required Information</div>
                )}
                <div className="btn-group">
                <button id="btnCancel" type="button" className="btn btn-primary-outline" onClick={props.handleCancel}>Cancel</button>
                <button id="btnReview" type="button" className="btn btn-primary" onClick={handleSaveClick}>Save and Review</button>
                </div>
            </div>
        </div>
        
    )

}


export default ObaManualFormComp;